//Todo: This can be taken out of this class
export function buildFormElements(configService) {
    let renderView = configService.getRenderView();
    let cards = [];
    let firstFocusableField = configService.getFirstFocusableField();
    let emptyRenderView = {
        ...renderView,
        fieldPath: firstFocusableField,
        value: {},
        cardSection: "root"
    };
    let currentCard = {
        data: { ...emptyRenderView },
        title: "",
        type: "section",
        containerField: { type: "section", key: "root" },
        cardSection: "root"
    };
    for (let [key, fieldRenderView] of Object.entries(renderView.value)) {
        let fieldConfig = configService.getConfig(fieldRenderView.configName);
        if (fieldConfig.type === "composedList") {
            if (currentCard) {
                cards.push(currentCard);
            }
            currentCard = {
                data: fieldRenderView,
                title: fieldConfig.label || "",
                type: "composedList",
                containerField: fieldConfig,
                cardSection: fieldConfig.key
            };
        }
        else if (fieldConfig.type === "section") {
            if (currentCard) {
                cards.push(currentCard);
            }
            currentCard = {
                data: {
                    ...fieldRenderView,
                    cardSection: fieldConfig.key,
                    value: {}
                }, title: fieldConfig.label || "", type: "section", containerField: fieldConfig
            };
        }
        else {
            currentCard.data.value[key] = fieldRenderView;
        }
    }
    if (Object.keys(currentCard.data).length > 0) {
        cards.push(currentCard);
    }
    //Filter out empty sections
    cards = cards.filter(card => {
        if (card.type === "composedList") {
            return true;
        }
        else {
            let activeCards = Object.values(card.data.value).filter((value) => value.active);
            return activeCards.length > 0;
        }
    });
    return cards;
}
